import styled from "styled-components";
import { borderRadius, spacing, typographyMixin } from "@magicbi/ui-library";

export const Strip = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${spacing[2]};
  padding: ${spacing[2]} ${spacing[3]};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.stroke};
  background: ${({ theme }) => theme.colors.surface.secondary};
`;

export const Card = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[2]};
  min-width: 0;
  max-width: 100%;
  min-height: 2.75rem;
  padding: ${spacing[1]} ${spacing[1]} ${spacing[1]} ${spacing[2]};
  border: 1px solid ${({ theme }) => theme.colors.border.stroke};
  border-radius: ${borderRadius.lg};
  background: ${({ theme }) => theme.colors.surface.primary};
`;

export const Text = styled.span`
  display: grid;
  min-width: 0;
`;

export const Title = styled.span`
  ${typographyMixin("caption", 1)}
  color: ${({ theme }) => theme.colors.text.primary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Meta = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${spacing[1]};
  ${typographyMixin("caption", 4)}
  color: ${({ theme }) => theme.colors.text.secondary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  svg {
    flex: none;
    width: 0.75rem;
    height: 0.75rem;
  }
`;

export const Actions = styled.span`
  display: flex;
  gap: ${spacing[0.5]};
  flex: none;
`;
